var _path, _path2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountImpactBottomDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 28",
    className: "AccountImpactPage_dot__Inbrj",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.92 18.39C21.98 10.76 5.78 9 0 9h48v18.77c-2.7.6-9.83.8-19.08-9.38z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.08 18.39C70.02 10.76 86.22 9 92 9H44v18.77c2.7.6 9.83.8 19.08-9.38z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 10.5,
    r: 5.5,
    fill: "#0055a5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 46.5,
    cy: 10.5,
    r: 10,
    stroke: "#001489"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountImpactBottomDot);
export default __webpack_public_path__ + "static/media/account-impact_bottom_dot.efebc20125dc2198740e7b3f1db8a6e6.svg";
export { ForwardRef as ReactComponent };